// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const mynumber: CountryValidator<"JP"> = createValidator(
  "jp.mynumber",
  108,
);

export default mynumber;
export const compact = mynumber.compact;
export const format = mynumber.format;
export const validate = mynumber.validate;
export const generate = (): string =>
  mynumber.generate?.() ??
  (() => {
    throw new Error(
      "Validator jp.mynumber cannot generate values",
    );
  })();
